import {useEffect, useState} from 'react';
import {GuidesEnum} from 'presentation/constants';
import {useMediaQueries} from 'presentation/pages';
import {useLocation, useNavigate} from 'react-router-dom';
import {usePostFavoritePlaceMutation} from '../mutations/usePostFavoritePlaceMutation';
import {AddressDataFormValues} from 'presentation/components/ChangeData/Address/AddressForm/validation';

export function useAddFavoritePlace() {
  const [openAddFavoritePlaceSuccess, setOpenAddFavoritePlaceSuccess] = useState(false);
  const [openAddFavoritePlaceError, setOpenAddFavoritePlaceError] = useState(false);
  const {isMobile, isTablet} = useMediaQueries();
  const navigate = useNavigate();
  const {state: routeState} = useLocation();
  const {
    mutate: postFavoritePlace,
    isPending: isPostingFavoritePlace,
    isSuccess: isPostFavoritePlaceSuccess,
    isError: isPostingFavoritePlaceError,
  } = usePostFavoritePlaceMutation();

  const handleOpenFavoritePlaceSuccess = () => {
    setOpenAddFavoritePlaceSuccess(true);
  };

  const handleCloseFavoritePlaceSuccess = () => {
    setOpenAddFavoritePlaceSuccess(false);
    navigate(GuidesEnum.SERVICE_NETWORK_HEALTH_FLOW_FAVORITE_PLACES_LIST);
  };

  const handleOpenAddFavoritePlaceError = () => {
    setOpenAddFavoritePlaceError(true);
  };

  const handleCloseAddFavoritePlaceError = () => {
    setOpenAddFavoritePlaceError(false);
  };

  useEffect(() => {
    if (isPostFavoritePlaceSuccess) {
      handleOpenFavoritePlaceSuccess();
    } else if (isPostingFavoritePlaceError) {
      handleOpenAddFavoritePlaceError();
    }
  }, [isPostFavoritePlaceSuccess, isPostingFavoritePlaceError]);

  const handleBack = () => {
    navigate(routeState?.from || GuidesEnum.SERVICE_NETWORK_HEALTH_FLOW_FAVORITE_PLACES_LIST);
  };

  const onSubmit = async (data: AddressDataFormValues) => {
    postFavoritePlace({data});
  };

  const isMobOrTab = isMobile || isTablet;

  return {
    isMobOrTab,
    handleBack,
    onSubmit,
    openAddFavoritePlaceSuccess,
    handleCloseFavoritePlaceSuccess,
    openAddFavoritePlaceError,
    handleCloseAddFavoritePlaceError,
    isPostingFavoritePlace,
  };
}
